module.exports = __webpack_public_path__ + "img/circle_s.3d620dd8.png";